export const RectAreEqual = (a: DOMRectReadOnly | null, b: DOMRectReadOnly | null) => {
  if (a === b) return true
  if (a === null || b === null) return false
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height
}
